import {apsEnums} from "../../shared/dto/aps.enums";
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import JobRunActivity from "./jobRunActivity";
import * as moment from "moment";
import * as _ from "lodash";
import {Strings} from "../../shared/config/constant.module";
import GobUtil from "../../services/utility/gob.utility";

export default class ToolActivity {
  toolType: apsEnums.ToolType;
  createdByFullName: string;
  rootComments: apsViewModels.ToolChangeDetailsComment[];
  shopId: string;
  defectTypeName: string;
  toolIsMold: boolean;
  otherReason: string;
  toolChangeId: string;
  id: string;
  isMachineId: string;
  section: number;
  gob: number;
  gobName: string;
  duration: number;
  timeChanged: Date;
  timeRemoved: Date;
  toolNumber: number;
  toolId: string;
  toolName: string;
  isMold: boolean;
  reason: apsEnums.ToolChangeReason;
  comment: string;
  defectId: string;
  defectDefectTypeName: string;
  unlistedDefect: boolean;
  defectTypeId: string;
  timeZone: string;
  jobRun: JobRunActivity;
  machineNumber: number;
  jobs: apsViewModels.JobItem[];
  jobProcess: apsViewModels.JobProcess[];
  eightyHrTools: string;
  oneSixtyHrTools: string;

  formatTime(time) {
    if (time) {
      return moment.utc(time).tz(this.timeZone).format(Strings.TIME_FORMAT);
    }
    return '';
  }

  constructor(toolActivity: apsViewModels.ToolActivity,
              timeZone: string,
              jobRun: JobRunActivity,
              machineNumber: number, 
              jobs: apsViewModels.JobItem[], 
              jobProcess: apsViewModels.JobProcess[],
              eightyHrTools: string,
              oneSixtyHrTools: string ) {
    _.assign(this, toolActivity);
    this.timeZone = timeZone;
    this.jobRun = jobRun;
    this.machineNumber = machineNumber;
    this.jobs = jobs;
    this.jobProcess = jobProcess;
    this.eightyHrTools = eightyHrTools;
    this.oneSixtyHrTools = oneSixtyHrTools;
  }

  getTimeChanged(): string {
    return this.formatTime(this.timeChanged);
  }

  getTimeRemoved(): string {
    return this.formatTime(this.timeRemoved);
  }

  getGobName(): string {
    return GobUtil.getGobName(this.gob, this.jobRun.numberOfGobs);
  }

  getSectionName(): string {
    if (!this.section) {
      return null;
    }
    return this.machineNumber < 2 ? this.section.toString()
      : (((this.machineNumber - 1) * this.jobRun.numberOfSections) + this.section).toString();
  }

  getColorCode():string{    

    var currentJob = this.jobs.filter(x => x.id === this.jobRun.jobId)[0];
    var process = this.jobProcess.filter(x => x.id == currentJob.processId)[0];
    let eightyHrTools = this.eightyHrTools.split(',');
    var oneSixtyHrTools = this.oneSixtyHrTools.split(',');
    eightyHrTools = process.name == "B&B" ? eightyHrTools.filter(x=> x !== 'Plunger Clip') : eightyHrTools;

    let totalHours = moment.utc().diff(this.timeChanged,'hours');
      var toolhrstype = _.includes(eightyHrTools, this.toolName) ? 'Eighty' 
      : _.includes(oneSixtyHrTools, this.toolName) ? 'OneSixty' : 'N/A' ;
  
      if((toolhrstype == 'Eighty' && totalHours > 92) || (toolhrstype == 'OneSixty' && totalHours > 160) ){
        return 'Red';
      }
      else if((toolhrstype == 'Eighty' && (totalHours >= 84 && totalHours <= 92)) || (toolhrstype == 'OneSixty' && (totalHours >= 154 && totalHours <= 160))){
        return 'Orange';
      }
      else if(toolhrstype == 'N/A'){ return null; }
      else {return 'Green';}
    }

  getDuration(): string {
    var startTime = moment.utc(this.timeChanged);
    if (this.timeRemoved) {
      var endTime = moment.utc(this.timeRemoved);
      return startTime.to(endTime, true);
    }
    return startTime.toNow(true);
  }

  getDurationAndHours(): string {
    var displayTime = this.getDuration();
    var startTime = moment.utc(this.timeChanged);
    var endTime = moment.utc();
    if (this.timeRemoved) {
      endTime = moment.utc(this.timeRemoved);
    }
    if (displayTime.search('day|week|month|year') > 0) {
        displayTime += ' / ' + endTime.diff(startTime, 'hour') + ' total hours';
    }
    return displayTime;
  }

  getReason(): string {
    if (this.reason === apsEnums.ToolChangeReason.Other) {
      return this.otherReason;
    }
    return _.startCase(apsEnums.ToolChangeReason[this.reason]);
  }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/models/activity/toolActivity.ts